import i18n from "../i18n";

/** Anciens messages FR renvoyés en string par l'API → code i18n */
const LEGACY_FR_TO_CODE = {
  "Email/Téléphone ou mot de passe incorrect": "AUTH_INVALID_CREDENTIALS",
  "Email/téléphone ou mot de passe incorrect": "AUTH_INVALID_CREDENTIALS",
  "Email ou téléphone requis": "AUTH_EMAIL_OR_PHONE_REQUIRED",
  "Compte administrateur désactivé": "AUTH_ACCOUNT_DISABLED_ADMIN",
  "Compte KAM désactivé": "AUTH_ACCOUNT_DISABLED_KAM",
  "Le mot de passe doit contenir au moins 6 caractères": "AUTH_PASSWORD_MIN",
  "Mot de passe actuel incorrect": "AUTH_CURRENT_PASSWORD_WRONG",
  "Cet email est déjà utilisé": "AUTH_EMAIL_ALREADY_USED",
  "Ce numéro de téléphone est déjà utilisé": "AUTH_PHONE_ALREADY_USED",
  "Accès non autorisé": "ACCESS_FORBIDDEN",
  "Utilisateur non trouvé": "NOT_FOUND_USER",
  "Pharmacie non trouvée": "NOT_FOUND_PHARMACY",
  "Compte introuvable": "NOT_FOUND_ACCOUNT",
  "Code invalide ou expiré": "RESET_CODE_INVALID",
  "Code expiré. Veuillez en demander un nouveau": "RESET_CODE_EXPIRED",
  "Token invalide ou expiré": "TOKEN_INVALID",
  "Token expiré. Veuillez recommencer": "TOKEN_EXPIRED",
  "Rôle inconnu": "ROLE_UNKNOWN",
  "Permission insuffisante pour cette action": "ADMIN_PERMISSION_DENIED",
};

const PYDANTIC_MSG_TO_CODE = {
  "Field required": "VALIDATION_FIELD_REQUIRED",
  "value is not a valid email address": "VALIDATION_EMAIL_INVALID",
};

function tError(code, params) {
  const key = code.startsWith("errors:") ? code : `errors:${code}`;
  return i18n.t(key, params || {});
}

function resolveLegacyMessage(message) {
  if (!message || typeof message !== "string") return null;
  const code = LEGACY_FR_TO_CODE[message.trim()];
  return code ? tError(code) : message;
}

function resolvePydanticMsg(msg) {
  if (!msg) return null;
  const code = PYDANTIC_MSG_TO_CODE[msg] || PYDANTIC_MSG_TO_CODE[msg.trim()];
  return code ? tError(code) : msg;
}

function resolveDetail(detail) {
  if (typeof detail === "string") {
    return resolveLegacyMessage(detail);
  }

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (item?.code) return tError(item.code, item.params);
        if (item?.msg) return resolvePydanticMsg(item.msg);
        return JSON.stringify(item);
      })
      .join(" · ");
  }

  if (detail && typeof detail === "object") {
    if (detail.code) {
      return tError(detail.code, detail.params);
    }
    if (detail.message) {
      return resolveLegacyMessage(detail.message) || detail.message;
    }
    if (Array.isArray(detail.errors)) {
      return detail.errors
        .map((item) => (item?.code ? tError(item.code, item.params) : item?.message || ""))
        .filter(Boolean)
        .join(" · ");
    }
  }

  return null;
}

/** Message lisible depuis une erreur axios / FastAPI (FR par défaut, EN si langue active) */
export function formatApiError(error, fallbackCode = "GENERIC_ERROR") {
  if (!error?.response) {
    return tError("NETWORK_ERROR");
  }

  const resolved = resolveDetail(error.response.data?.detail);
  if (resolved) return resolved;

  return tError(fallbackCode);
}
